<div
  class="container"
  [ngClass]="{
    'container_final': isCompleted
  }"
>
  <app-section-full class="container__section"
    *ngIf="isCompleted"
  >
    <ng-container *ngTemplateOutlet="sectionLeft"></ng-container>
  </app-section-full>
  <app-section-left class="container__section container__section_left"
    *ngIf="!isCompleted"
  >
    <ng-container *ngTemplateOutlet="sectionLeft"></ng-container>
  </app-section-left>
  <app-section-right class="container__section container__section_right" *ngIf="!isCompleted">
    <app-aside
      [orderId]="orderData?.orderId"
      [books]="orderData?.books"
      [shipping]="shipping"
    ></app-aside>
  </app-section-right>
  <app-header class="container__section container__section_header header"
    [step]="step"
    *ngIf="media.isActive('lt-xl')"
  ></app-header>
</div>

<ng-template #sectionLeft>
  <app-header class="header"
    [step]="step"
    [steps]="[{
      id: 1,
      name: 'お客さま情報入力'
    }, {
      id: 2,
      name: '配送方法選択'
    }, {
      id: 3,
      name: 'お支払い'
    }]"
    *ngIf="media.isActive('gt-lg')"
  ></app-header>
  <app-main
    class="main"
    *ngIf="!isCompleted"
    [(step)]="step"
    (dataChange)="onChange($event)"
    [disabledShippingNames]="disabledShippingNames"
    [shippings]="shippings"
    [shipping]="shipping"
    (nextClick)="nextClick()"
    [isNextDisabled]="isNextDisabled"
  ></app-main>
  <app-final class="main" *ngIf="isCompleted"
    [barOrderId]="orderData?.barOrderId"
  ></app-final>
  <app-footer
    class="footer"
    [isFinal]="isFinalStep"
    [nextText]="
      isFinalStep ?
        'お支払いを完了する' :
      step === 2 ?
        'お支払いに進む' :
        '配送方法選択にすすむ'
    "
    [isCompleted]="isCompleted"
    [isBackDisabled]="isBackDisabled"
    [isNextDisabled]="isNextDisabled"
    (back)="backClick()"
    (next)="nextClick()"
  ></app-footer>
</ng-template>
